const cssStyles = () => `
.FullPageModal__scroller {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
`;

export default cssStyles;
